export default {
  BookingReviewHeader: '19122018-161314-4120'
};
